<template>
  <div class="wrap">
    <div class="banner">
        <div class="content">
            <div class="countdown-box ofh">
                <div class="inner df ai-c js-c">
                    <span class="txt">距今天活动结束：</span>
                    <span class="num">{{ this.countData.time }}</span>
                    <span class="txt">时</span>
                    <span class="num">{{ this.countData.minute }}</span>
                    <span class="txt">分</span>
                    <span class="num">{{ this.countData.second }}</span>
                    <span class="txt">秒</span>
                    <span class="num">{{ this.countData.millisecond }}</span>
                </div>
            </div>
             <i class="points-mark"></i>
        </div>
    </div>
    <div class="module-item floorItem vip-lifelong-item"
    id="floor2"
    data-floor="2"
    >
      <div class="content">
        <div class="vip-box vip-box02 df" @click="showVip(1)">
          <div class="lt f1">
            <div class="tit df ai-c js-c">3年超级VIP</div>
            <div class="df ai-c">
              <div class="sub sub1 f1 df fdc ai-c">
                <div>
                  <p class="txt1">充一享三</p>
                  <p class="txt2">免费领取1门精品课 <br> 赠199元AI点数套餐</p>
                </div>
              </div>
              <div class="sub sub2 f1 tac">
                <div>
                  <p class="txt1">398<span class="unit">元</span></p>
                  <p class="txt2"><del>标准价：￥598</del></p>
                </div>
              </div>
            </div>
          </div>
          <div class="rt">
            <div class="vip-btn hide-text">
              立即抢购
            </div>
          </div>
        </div>
        <a href="https://lartai.art/" target="_blank" class="lartai-box">
          <img src="~@/assets/images/activity/vip/001/202607/lartai.png" alt="" class="lartai">
          <i class="view-btn hide-text">点击查看</i>
        </a>
        <div class="course-box course-box02">
          <div class="inner">
            <div class="module-title">
              <div class="title df ai-c js-c tac">以下精品好课免费任选其一<br/>单课最高价值￥399</div>
              <div class="sub-title tac">~赠送课程不定期更换，喜欢本期课程的童鞋不要错过哦~</div>
            </div>
            <div class="course-list tal">
                <a target="_blank" class="item df fdc"
                v-for="(item, index) in courseData2.slice(0,6)"
                :key="index"
                :href="`${$commonVariable.yihu_href_url}/a_${item.album_id}.html`"
                >
                    <div class="course-top">
                      <img v-lazy="item.album_smpicpath" alt="" class="cover">
                      <!-- <img src="https://img12.yiihuu.com/upimg/album/2020/11/17/1-1605578439-197173.jpg" alt="" class="cover"> -->
                    </div>
                    <div class="course-mid f1">
                        <div class="course-tit limite-line-2">
                            {{item.album_name}}
                        </div>
                    </div>
                    <div class="course-bot df ai-c js-sb">
                        <div class="txt">
                          优惠价 <span class="price">￥{{item.album_price}}</span>
                        </div>
                        <span href="javascript:;" class="course-btn df ai-c js-c">了解详情</span>
                    </div>
                </a>
            </div>
            <p class="cousre-tips">
              领课说明：3年VIP充值成功后，可在“个人中心-我的学习卡”处查看赠课，以上6门课程可<span>任选1门</span>兑换学习，兑换后免费观看时限为<span>90天</span>，过期无效，记得在有效期内领取学习哦！
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="module-item floorItem vip-year-item"
    id="floor1"
    data-floor="1"
    >
      <div class="content">
        <div class="vip-box df" @click="showVip()">
          <div class="lt f1">
            <div class="tit df ai-c js-c">超级1年VIP</div>
            <div class="df ai-c">
              <div class="sub sub1 f1 df fdc ai-c">
                <div>
                  <p class="txt1">直降￥70</p>
                  <p class="txt2">免费加赠价值199学习卡</p>
                </div>
              </div>
              <div class="sub sub2 f1 tac">
                <div>
                  <p class="txt1">128<span class="unit">元</span></p>
                  <p class="txt2"><del>标准价￥198</del> (约0.35元/天)</p>
                </div>
              </div>
            </div>
          </div>
          <div class="rt">
            <div class="vip-btn hide-text">
              立即抢购
            </div>
          </div>
        </div>
        <div class="course-box">
          <div class="inner">
            <div class="module-title">
              <div class="title df ai-c js-c tac">1年VIP赠价值199元学习卡<br/>以下6门精品课可任选1门</div>
              <div class="sub-title tac">~赠送课程不定期更换，喜欢本期课程的童鞋不要错过哦~</div>
            </div>
            <div class="course-list tal">
                <a target="_blank" class="item df fdc"
                v-for="(item, index) in courseData1.slice(0,6)"
                :key="index"
                :href="`${$commonVariable.yihu_href_url}/a_${item.album_id}.html`"
                >
                    <div class="course-top">
                      <img v-lazy="item.album_smpicpath" alt="" class="cover">
                      <!-- <img src="https://img12.yiihuu.com/upimg/album/2020/11/17/1-1605578439-197173.jpg" alt="" class="cover"> -->
                    </div>
                    <div class="course-mid f1">
                        <div class="course-tit limite-line-2">
                            {{item.album_name}}
                        </div>
                    </div>
                    <div class="course-bot df ai-c js-sb">
                        <div class="txt">
                          优惠价 <span class="price">￥{{item.album_price}}</span>
                        </div>
                        <span href="javascript:;" class="course-btn df ai-c js-c">了解详情</span>
                    </div>
                </a>
            </div>
            <p class="cousre-tips">
              领课说明：1年VIP充值成功后，可在“个人中心-我的学习卡”处查看赠课，以上6门课程可<span>任选1门</span>兑换学习，兑换后免费观看时限为<span>60天</span>，过期无效，记得在有效期内领取学习哦！
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="module-item floorItem vip-rights-item"
    id="floor3"
    data-floor="3"
    >
      <div class="content">
        <div class="join-box">
            <!-- <div class="item join-item df fdc js-c"
            v-for="(item, index) in joinData"
            :key="index">
                <p class="txt1">{{ item.txt1 }}</p>
                <p class="txt2">{{ item.txt2 }}</p>
                <span class="mark df ai-c js-c" v-if="index==joinData.length-1">限时加赠</span>
            </div> -->
            <a class="item join-item df fdc js-c" target="_blank"
            v-for="(item, index) in joinData"
            :key="index"
            :href="item.link"
            >
              <p class="txt1">{{ item.txt1 }}</p>
              <p class="txt2">{{ item.txt2 }}</p>
              <span class="mark df ai-c js-c" v-if="index==joinData.length-1">限时加赠</span>
          </a>
        </div>
        <a href="javascript:;" class="join-btn df ai-c js-c"
        @click="showVip()">加入VIP，享更多权益</a>
        <div class="module-title">
          <div class="title df ai-c js-c">普通用户和VIP特权对比</div>
        </div>
        <div class="module-cnt">
          <p class="tac"><img src="~@/assets/images/activity/vip/001/vip_table.png" alt="" class="vip-table"></p>
        </div>
      </div>
    </div>
    <div class="module-item pt0">
      <div class="content">
        <div class="module-title">
          <div class="title df ai-c js-c">常见问题解答</div>
        </div>
        <ul class="answer-box">
          <li
          v-for="(item, index) in answerData"
          :key="index"
          :class="{
            show:item.show
          }"
          >
            <div class="ask df js-sb"
            @click="showAnswer(index)"
            >
              <div class="df">
                <span>Q：</span>
                <span>{{ item.ask}}</span>
              </div>
              <!-- <i class="icon"></i> -->
            </div>
            <p class="answer">
              <span>A：</span>
              <span>{{ item.answer}}</span>
            </p>
          </li>
        </ul>
        <p class="answer-tips tac">
          最终解释权在法律允许范围内归翼狐网所有
        </p>
      </div>
    </div>
    <!-- 左侧导航 -->
    <!-- <ModuleFloor :floorData="floorData"></ModuleFloor> -->

    <el-dialog custom-class="vip-dialog" title="温馨提示"
      :visible.sync="dialogVisible"
      width="86%"
      center
      dialogVisible>
      <p class="tac">购买成功，请到<a href="https://lartai.art/" target="_blank" style="color: #ed626b;">【LartAI】</a>查看充值点数。</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {getCourseData} from "@/api/activity/viphd/001"

// import ModuleFloor from "./components/ModuleFloor"

let joinData=[
    { txt1:'10大行业', txt2:'13803+VIP课时任意学',txt3:'持续上新课时无限次学',link:'/vip/'},
    { txt1:'56+款软件', txt2:'入门技能全覆盖',txt3:'助你零基础到精通',link:'/vip/'},
    { txt1:'专享特价', txt2:'单付费课享会员折扣',txt3:'VIP购课惊喜折上折',link:'/bc/'},
    { txt1:'主流热门模型', txt2:'Seedance 2.0/Seedream 5.0等',txt3:'每日赠送免费点数',link:'https://lartai.art/'},
]
let answerData=[
    { ask:'如何充值？', answer:'翼狐网VIP目前支持支付宝、花呗、微信、京东支付等多种支付方式，具体请查看支付页面。',show:false},
    { ask:'开通会员后，会员权益何时生效？', answer:'开通会员立即生效，续费会员有效期自动叠加。会员过期后续费不享受续费价格。',show:false },
    { ask:'VIP是否可以观看站内所有教程？', answer:'不是，翼狐网教程有两种: VIP教程＆单付费教程；需开通超级VIP才能观看VIP专区教程学习；单付费教程需另外付费购买，可享受VIP优惠价。' ,show:false},
    { ask:'分类VIP和超级VIP有什么区别？', answer:'【分类VIP】只能观看VIP专区单一分类教程；【超级VIP】网站VIP专区内所有VIP教程均可无限观看学习；' ,show:false},
    { ask:'可以提供软件和配套文件吗？', answer:'由于版权原因,无法提供软件下载，开通VIP或购买教程后即可下载配套文件，边学边练。',show:false },
    { ask:'教程视频是否可以下载观看？', answer:'电脑端暂时只能在线观看。下载【翼狐APP】可以离线缓存视频；温馨提示: APP缓存的视频只能在APP上观看。' ,show:false},
    { ask:'购买后支持退款吗？', answer:'在VIP有效期内视频可以反复观看，由于VIP视频是虚拟物品，购买之后不支持退款，我们提供了部分免费试看视频，请试看之后慎重购买。' ,show:false},
    { ask:'充值了VIP，但是无法观看视频？', answer:'首先确认VIP充值类型是否有误，若VIP类型充值错误，当天内可联系客服更换。若出现其他错误，亦可联系客服(QQ:389559687)处理。',show:false },
]
let floorData=[
{
  floor_id:'2',
  floor_name:'免费领取1门课'
},
{
  floor_id:'1',
  floor_name:'VIP直降￥70'
},
{
  floor_id:'3',
  floor_name:'VIP专享权益'
},
]
export default {
 name: "VipHd001",
 components: {
    // ModuleFloor,
  },
  data() {
    return {
      countData: {
          time: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
      },
      initData:{},
      joinData,
      answerData,
      floorData,
      extraData:{},
      dialogVisible: false,
    }
  },
  created() {

  },
  mounted() {
      this.showTime()

      this.getInitDataFn()
  },
  computed:{
    courseData1:function(){
      return this.initData?.one_year??[]
    },
    courseData2:function(){
      return this.initData?.three_year??[]
    }
  },
  methods: {
    showTime(){
        let timerObj;
        let nowtime = new Date();
        let endtime = new Date(nowtime.getFullYear(), nowtime.getMonth(), nowtime.getDate(), 23, 59, 59, 999);
        let lefttime = parseInt((endtime.getTime() - nowtime.getTime()));
        let d = parseInt(lefttime / 1000 / (24 * 60 * 60));
        let h = parseInt(lefttime / 1000 / (60 * 60) % 24);
        let m = parseInt(lefttime / 1000 / 60 % 60);
        let s = parseInt(lefttime / 1000 % 60);
        let ms = parseInt(lefttime / 1000);
        if (lefttime > 0) {
            d = parseInt(lefttime / 1000 / 60 / 60 / 24);
            h = parseInt(lefttime / 1000 / 60 / 60 % 24);
            m = parseInt(lefttime / 1000 / 60 % 60);
            s = parseInt(lefttime / 1000 % 60);
            ms = parseInt(lefttime % 1000);
        } else {
            h = m = s = "00";
            ms = '000';
        }
        d = this.PrefixInteger(d, 2);
        h = this.PrefixInteger(h, 2);
        m = this.PrefixInteger(m, 2);
        s = this.PrefixInteger(s, 2);
        ms = this.PrefixInteger(ms, 3);

        if (lefttime <= 0) {
            timerObj && clearTimeout(timerObj);
            window.location.reload(true);
        }
        this.countData = {
            time: h,
            minute: m,
            second: s,
            millisecond: ms,
        };
        timerObj = setTimeout(this.showTime, 40); 
    },
    PrefixInteger(num, length) {
        return (Array(length).join("0") + num).slice(-length);
    },
    async getInitDataFn(){
      let res=await getCourseData()
      let {data}=res
      this.initData=data
      this.dialogVisible=Boolean(data?.show_lartai_popup)
    },
    //VIP弹窗
    showVip(vip_cate_child_id = 0) {//vip_cate_child_id: 0:年vip 1:3年vip
        if (/isapp/i.test(this.uApp)) {//当前h5页面在APP内打开
            this.h5Data = {
                jumpData: {
                    jump_to_type: 2,
                    level: 2 //跳vip权益页
                }
            };
            this.sendEventAction(this.h5Data);
        } else {
            // alert('不是在app内打开')
            // alert(navigator.userAgent)
            if(vip_cate_child_id==1){
              location.href = this.$commonVariable.yihu_href_url + '/pay/wxpay1/buyvip_new.php?vip_type=45&three_vip=1&page_param=vip_001';// three_vip=1跳转至3年vip ,lifetime_vip=1跳转至终身vip
            }else{
              location.href = this.$commonVariable.yihu_href_url + '/pay/wxpay1/buyvip_new.php?vip_type=45&page_param=vip_001';// vip_type:设置默认的vip来源类型
            }
        }
    },
    //h5页面通知APP，回传数据给APP
    sendEventAction(h5Data) {
        // console.log(`h5Data:${JSON.stringify(h5Data)}`)
        // console.log(`extraData:${JSON.stringify(extraData)}`)

        // 跟app交互主要方法
        // h5CallbackData、extraData 空值传{}
        // 跳转能力调用app内首页openEntrance方法
        api.sendEvent({
            name: 'h5CallbackEvent',
            extra: {
                h5CallbackData: h5Data,
                extraData: this.extraData
            }
        });
    },
    showAnswer(index_){
      this.answerData.forEach((item,index,arr)=>{
        if(index_==index){
          item.show=!item.show
        }else{
          item.show=false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped src="@/assets/css/activity/vip/001.scss"></style>